var _map = [].concat(Array(7)).map(function (el, index) {
    return index;
  }),
  // eslint-disable-next-line no-unused-vars
  SUNDAY = _map[0],
  MONDAY = _map[1],
  TUESDAY = _map[2],
  WEDNESDAY = _map[3],
  THURSDAY = _map[4],
  FRIDAY = _map[5],
  SATURDAY = _map[6];

/* Simple getters - getting a property of a given point in time */

export var getYear = function getYear(date) {
  if (date instanceof Date) {
    return date.getFullYear();
  }
  if (typeof date === 'number') {
    return date;
  }
  var year = parseInt(date, 10);
  if (typeof date === 'string' && !isNaN(year)) {
    return year;
  }
  throw new Error("Failed to get year from date: " + date + ".");
};
export var getMonth = function getMonth(date) {
  return date && date.getMonth() + 1;
};
export var getMonthIndex = function getMonthIndex(date) {
  var tempDate = date;
  if (typeof tempDate == 'string') {
    tempDate = new Date(date);
  }
  return tempDate && tempDate.getMonth();
};
export var getDay = function getDay(date) {
  var tempDate = date;
  if (typeof tempDate == 'string') {
    tempDate = new Date(date);
  }
  return tempDate && tempDate.getDate();
};
export var getDayOfWeek = function getDayOfWeek(date, firstDayOfWeek) {
  if (firstDayOfWeek === void 0) {
    firstDayOfWeek = 0;
  }
  var weekday = date.getDay();
  return (weekday + 6 - firstDayOfWeek) % 7;
};

/* Complex getters - getting a property somehow related to a given point in time */
export function getFullDate(year, month, day, hour, min, sec, milsec) {
  var a = new Date(2000, 0, 1, 0, 0, 0, 0);
  //Values from 0 to 99 map to the years 1900 to 1999
  if (typeof year === 'number') {
    a.setFullYear(year);
  }
  if (typeof month === 'number') {
    a.setMonth(month);
  }
  if (typeof day === 'number') {
    a.setDate(day);
  }
  if (typeof hour === 'number') {
    a.setHours(hour);
  }
  if (typeof min === 'number') {
    a.setMinutes(min);
  }
  if (typeof sec === 'number') {
    a.setSeconds(sec);
  }
  if (typeof milsec === 'number') {
    a.setMilliseconds(milsec);
  }
  return a;
}
export var getBeginOfCenturyYear = function getBeginOfCenturyYear(date) {
  var year = getYear(date) - 1;
  return year + -year % 100 + 1;
};
export var getBeginOfCentury = function getBeginOfCentury(date) {
  var beginOfCenturyYear = getBeginOfCenturyYear(date);
  return getFullDate(beginOfCenturyYear, 0, 1);
};
export var getEndOfCentury = function getEndOfCentury(date) {
  var beginOfCenturyYear = getBeginOfCenturyYear(date);
  return getFullDate(beginOfCenturyYear + 100, 0, 1, 0, 0, 0, -1);
};
export var getCenturyRange = function getCenturyRange(date) {
  return [getBeginOfCentury(date), getEndOfCentury(date)];
};
export var getBeginOfPreviousCentury = function getBeginOfPreviousCentury(date) {
  var previousCenturyYear = getYear(date) - 100;
  return getBeginOfCentury(previousCenturyYear);
};
export var getEndOfPreviousCentury = function getEndOfPreviousCentury(date) {
  var previousCenturyYear = getYear(date) - 100;
  return getEndOfCentury(previousCenturyYear);
};
export var getBeginOfNextCentury = function getBeginOfNextCentury(date) {
  var nextCenturyYear = getYear(date) + 100;
  return getBeginOfCentury(nextCenturyYear);
};
export var getBeginOfDecadeYear = function getBeginOfDecadeYear(date) {
  var year = getYear(date) - 1;
  return year + -year % 12 + 2;
};
export var getBeginOfDecade = function getBeginOfDecade(date) {
  var beginOfDecadeYear = getBeginOfDecadeYear(date);
  return getFullDate(beginOfDecadeYear, 0, 1);
};
export var getEndOfDecade = function getEndOfDecade(date) {
  var beginOfDecadeYear = getBeginOfDecadeYear(date);
  return getFullDate(beginOfDecadeYear + 10, 0, 1, 0, 0, 0, -1);
};
export var getDecadeRange = function getDecadeRange(date) {
  return [getBeginOfDecade(date), getEndOfDecade(date)];
};
export var getBeginOfPreviousDecade = function getBeginOfPreviousDecade(date, offset) {
  if (offset === void 0) {
    offset = 10;
  }
  var previousDecadeYear = getBeginOfDecadeYear(date) - offset;
  return getBeginOfDecade(previousDecadeYear);
};
export var getEndOfPreviousDecade = function getEndOfPreviousDecade(date, offset) {
  if (offset === void 0) {
    offset = 10;
  }
  var previousDecadeYear = getBeginOfDecadeYear(date) - offset;
  return getEndOfDecade(previousDecadeYear);
};
export var getBeginOfNextDecade = function getBeginOfNextDecade(date, offset) {
  if (offset === void 0) {
    offset = 12;
  }
  var nextDecadeYear = getBeginOfDecadeYear(date) + offset;
  return getBeginOfDecade(nextDecadeYear);
};

/**
 * Returns the beginning of a given year.
 *
 * @param {Date} date Date.
 */
export var getBeginOfYear = function getBeginOfYear(date) {
  var year = getYear(date);
  return getFullDate(year, 0, 1);
};

/**
 * Returns the end of a given year.
 *
 * @param {Date} date Date.
 */
export var getEndOfYear = function getEndOfYear(date) {
  var year = getYear(date);
  return getFullDate(year + 1, 0, 1, 0, 0, 0, -1);
};

/**
 * Returns an array with the beginning and the end of a given year.
 *
 * @param {Date} date Date.
 */
export var getYearRange = function getYearRange(date) {
  return [getBeginOfYear(date), getEndOfYear(date)];
};
export var getBeginOfPreviousYear = function getBeginOfPreviousYear(date, offset) {
  if (offset === void 0) {
    offset = 1;
  }
  var previousYear = getYear(date) - offset;
  return getBeginOfYear(previousYear);
};
export var getEndOfPreviousYear = function getEndOfPreviousYear(date, offset) {
  if (offset === void 0) {
    offset = 1;
  }
  var previousYear = getYear(date) - offset;
  return getEndOfYear(previousYear);
};
export var getBeginOfNextYear = function getBeginOfNextYear(date, offset) {
  if (offset === void 0) {
    offset = 1;
  }
  var nextYear = getYear(date) + offset;
  return getBeginOfYear(nextYear);
};

/**
 * Returns the beginning of a given month.
 *
 * @param {Date} date Date.
 */
export var getBeginOfMonth = function getBeginOfMonth(date) {
  var year = getYear(date);
  var monthIndex = getMonthIndex(date);
  return getFullDate(year, monthIndex, 1);
};

/**
 * Returns the end of a given month.
 *
 * @param {Date} date Date.
 */
export var getEndOfMonth = function getEndOfMonth(date) {
  var year = getYear(date);
  var monthIndex = getMonthIndex(date);
  return getFullDate(year, monthIndex + 1, 1, 0, 0, 0, -1);
};

/**
 * Returns the beginning of a given week.
 *
 * @param {Date} date Date.
 */
export var getBeginOfWeek = function getBeginOfWeek(date, firstDayOfWeek) {
  if (firstDayOfWeek === void 0) {
    firstDayOfWeek = 0;
  }
  var year = getYear(date);
  var monthIndex = getMonthIndex(date);
  var day = date.getDate() - getDayOfWeek(date, firstDayOfWeek);
  return getFullDate(year, monthIndex, day);
};

/**
 * Returns an array with the beginning and the end of a given month.
 *
 * @param {Date} date Date.
 */
export var getMonthRange = function getMonthRange(date) {
  return [getBeginOfMonth(date), getEndOfMonth(date)];
};
var getDifferentMonth = function getDifferentMonth(date, offset) {
  var year = getYear(date);
  var previousMonthIndex = getMonthIndex(date) + offset;
  return getFullDate(year, previousMonthIndex, 1);
};
export var getBeginOfPreviousMonth = function getBeginOfPreviousMonth(date, offset) {
  if (offset === void 0) {
    offset = 1;
  }
  var previousMonth = getDifferentMonth(date, -offset);
  return getBeginOfMonth(previousMonth);
};
export var getEndOfPreviousMonth = function getEndOfPreviousMonth(date, offset) {
  if (offset === void 0) {
    offset = 1;
  }
  var previousMonth = getDifferentMonth(date, -offset);
  return getEndOfMonth(previousMonth);
};
export var getBeginOfNextMonth = function getBeginOfNextMonth(date, offset) {
  if (offset === void 0) {
    offset = 1;
  }
  var nextMonth = getDifferentMonth(date, offset);
  return getBeginOfMonth(nextMonth);
};
export var getBeginOfDay = function getBeginOfDay(date) {
  var year = getYear(date);
  var monthIndex = getMonthIndex(date);
  var day = getDay(date);
  return getFullDate(year, monthIndex, day);
};
export var getEndOfDay = function getEndOfDay(date) {
  var year = getYear(date);
  var monthIndex = getMonthIndex(date);
  var day = getDay(date);
  return getFullDate(year, monthIndex, day + 1, 0, 0, 0, -1);
};

/**
 * Returns an array with the beginning and the end of a given day.
 *
 * @param {Date} date Date.
 */
export var getDayRange = function getDayRange(date) {
  return [getBeginOfDay(date), getEndOfDay(date)];
};
export var getBeginNext = function getBeginNext(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getBeginOfNextCentury(date);
    case 'decade':
      return getBeginOfNextDecade(date);
    case 'year':
      return getBeginOfNextYear(date);
    case 'month':
      return getBeginOfNextMonth(date);
    default:
      throw new Error("Invalid rangeType: " + rangeType);
  }
};
export var getEnd = function getEnd(rangeType, date) {
  if (!date) return;
  switch (rangeType) {
    case 'century':
      return getEndOfCentury(date);
    case 'decade':
      return getEndOfDecade(date);
    case 'year':
      return getEndOfYear(date);
    case 'month':
      return getEndOfMonth(date);
    case 'day':
      return getEndOfDay(date);
    default:
      throw new Error("Invalid rangeType: " + rangeType);
  }
};
export var getEndPrevious = function getEndPrevious(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getEndOfPreviousCentury(date);
    case 'decade':
      return getEndOfPreviousDecade(date);
    case 'year':
      return getEndOfPreviousYear(date);
    case 'month':
      return getEndOfPreviousMonth(date);
    default:
      throw new Error("Invalid rangeType: " + rangeType);
  }
};

/**
 * Returns an array with the beginning and the end of a given range.
 *
 * @param {String} rangeType Range type (e.g. 'day')
 * @param {Date} date Date.
 */
export var getRange = function getRange(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getCenturyRange(date);
    case 'decade':
      return getDecadeRange(date);
    case 'year':
      return getYearRange(date);
    case 'month':
      return getMonthRange(date);
    case 'day':
      return getDayRange(date);
    default:
      throw new Error("Invalid rangeType: " + rangeType);
  }
};

/**
 * Creates a range out of two values, ensuring they are in order and covering entire period ranges.
 *
 * @param {String} rangeType Range type (e.g. 'day')
 * @param {Date} date1 First date.
 * @param {Date} date2 Second date.
 */
export var getValueRange = function getValueRange(rangeType, date1, date2, momentUtils) {
  if (date1 instanceof Array) date1 = date1[0];
  var rawNextValue = [date1, date2].sort(function (a, b) {
    return a - b;
  });
  return [momentUtils.getStartDate(rawNextValue[0], rangeType), getEnd(rangeType, rawNextValue[1])];
};

/**
 * Returns a number of days in a month of a given date.
 *
 * @param {Date} date Date.
 */
export var getDaysInMonth = function getDaysInMonth(date) {
  var year = getYear(date);
  var monthIndex = getMonthIndex(date);
  return getFullDate(year, monthIndex + 1, 0).getDate();
};
var toYearLabel = function toYearLabel(_ref) {
  var start = _ref[0],
    end = _ref[1];
  return getYear(start) + " \u2013 " + getYear(end);
};

/**
 * Get the decade label of different language
 * @param language
 * @param locale
 * @returns
 */
export var getDecade = function getDecade(language, locale) {
  var _language;
  return (_language = language[locale || '']) === null || _language === void 0 ? void 0 : _language.selectYear;
};

/**
 * Returns a string labelling a century of a given date.
 * For example, for 2017 it will return 2001-2100.
 *
 * @param {Date|String|Number} date Date or a year as a string or as a number.
 */
export var getCenturyLabel = function getCenturyLabel(date) {
  return toYearLabel(getCenturyRange(date));
};

/**
 * Returns a string labelling a century of a given date.
 * For example, for 2017 it will return 2011-2020.
 *
 * @param {Date|String|Number} date Date or a year as a string or as a number.
 */
export var getDecadeLabel = function getDecadeLabel(date) {
  return toYearLabel(getDecadeRange(date));
};

/**
 * Returns a boolean determining whether a given date is on Saturday or Sunday.
 *
 * @param {Date} date Date.
 */
export var isWeekend = function isWeekend(date) {
  var weekday = date.getDay();
  return weekday === SATURDAY || weekday === SUNDAY;
};